import Character from "./Character";
import { CLASS_NAMES, DIRS } from "../../utils/constants";
import UI from "../UI";

export default class Enemy extends Character {
  constructor(id, level) {
    super(id, level);
    this.moveIntentDir = DIRS.UP;
    this.scanDirection = "CW";
    this.anchorPosition = null;
    this.line1 = null;
    this.debug = false;
  }
  
  addedToScene() {
    if (this.debug) {
      this.directionLine = this.level.scene.add.line(
        // obj position = tile with 0.5 offset
        UI.tileToScreen(this.position.x) + UI.tileToScreen(1) / 2,
        UI.tileToScreen(this.position.y) + UI.tileToScreen(1) / 2,
        // start point of line
        0,
        0,
        // end point of line
        0,
        -UI.tileToScreen(1),
        0x0000ff
      );
      this.directionLine.setRotation(Math.PI / 2);
      this.directionLine.width = 1; // keep it this size for rotation to properly apply
      this.directionLine.height = 1; // keep it this size for rotation to properly apply
      this.directionLine.setOrigin(0.5, 0.5);

      this.anchorLine = this.level.scene.add.line(
        // obj position = tile with 0.5 offset
        UI.tileToScreen(this.position.x) + UI.tileToScreen(1) / 2,
        UI.tileToScreen(this.position.y) + UI.tileToScreen(1) / 2,
        // start point of line
        0,
        0,
        // end point of line
        0,
        -UI.tileToScreen(1),
        0x00ff00
      );
      this.anchorLine.setRotation(Math.PI / 2);
      this.anchorLine.width = 1; // keep it this size for rotation to properly apply
      this.anchorLine.height = 1; // keep it this size for rotation to properly apply
      this.anchorLine.setOrigin(0.5, 0.5);
    }
  }
  overrunBy(el) {
    if (!el.isClass(CLASS_NAMES.PLAYER)) {
      // this.alien.visible = false
      // this.alien.alpha = 0.5
      this.alien?.destroy();
      this.line1?.destroy();
      this.level.onCharacterDie(this);
      this.level.onEnemyKill(this)
    }
    if (el.isClass(CLASS_NAMES.BOULDER) || el.isClass(CLASS_NAMES.JEWEL)) {
      this.level.scene.events.emit("sounds:death_by_rock_hit");
    }

    this.level.enemy_die_effect.x = this.alien.x;
    this.level.enemy_die_effect.y = this.alien.y;
    this.level.enemy_die_effect.play("enemy_dies");
  }
  loop() {
    if (this.moveIntentDir === DIRS.RIGHT && this.alien.flipX) {
      this.alien.setFlipX(false);
    }
    if (this.moveIntentDir === DIRS.LEFT && !this.alien.flipX) {
      this.alien.setFlipX(true);
    }

    if (this.debug) {
      this.directionLine.setPosition(
        UI.tileToScreen(this.position.x) + UI.tileToScreen(1) / 2,
        UI.tileToScreen(this.position.y) + UI.tileToScreen(1) / 2
      );
      this.directionLine.setRotation(
        this.moveIntentDir === DIRS.UP
          ? 0
          : this.moveIntentDir === DIRS.RIGHT
          ? Math.PI / 2
          : this.moveIntentDir === DIRS.DOWN
          ? Math.PI
          : (3 * Math.PI) / 2
      );
      if (this.anchorPosition) {
        // console.log(this.anchorPosition);
        this.anchorLine.setPosition(
          UI.tileToScreen(this.position.x) + UI.tileToScreen(1) / 2,
          UI.tileToScreen(this.position.y) + UI.tileToScreen(1) / 2
        );

        this.anchorLine.setRotation(
          this.anchorPosition.y < this.position.y
            ? 0
            : this.anchorPosition.x > this.position.x
            ? Math.PI / 2
            : this.anchorPosition.y > this.position.y
            ? Math.PI
            : (3 * Math.PI) / 2
        );
      }
    }
  }
}

Enemy.className = CLASS_NAMES.ENEMY;
